<template>
	<div id="new-menu">
      <form-menu editingMode="create"></form-menu>
    <br/>
	</div>
</template>

<script>
import api from "../../api"
import formMenu from './formMenu'
export default {
	name: "newMenu",
  components: {
    formMenu
  }
}
</script>

<style lang='css'>
#new-menu {
	color: #53574D
}
</style>

